var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('table-list', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], ref: "table", staticClass: "invoice-table-list", attrs: { "list": _vm.invoices || [], "column-config": _vm.columnConfig, "table-config": _vm.tableConfig } }, [_c('el-table-column', { attrs: { "slot": "select", "label": "Choose", "width": 70, "class-name": "invoice-select-column" }, slot: "select", scopedSlots: _vm._u([{ key: "default", fn: function fn(scope) {
        return _c('el-radio', { attrs: { "label": scope.row.id }, model: { value: _vm.currentInvoice, callback: function callback($$v) {
              _vm.currentInvoice = $$v;
            }, expression: "currentInvoice" } });
      } }]) })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };